<template>
  <div>
    <!-- Total sesiones registradas -->
    <TotalComplaints
      :styleWidth="'w-80'"
      :total="count"
      title="Total de sesiones"
      :body="totalFacilitatorsBody"
    />

    <!-- Filtro de busqueda de sesiones -->
    <SessionsFilter
      :key="$route.fullPath"
      :loading="loading"
      :searching="searching"
      @getFilterForm="setFilterForm"
      :userFacilitatorId="userFacilitatorId"
    />

    <div class="w-full grid grid-cols-12 gap-4 mb-2 mx-4 mt-4">
      <div class="col-span-12 text-left">
        <!-- Contenedor principal de las pestañas de Ant Design Vue -->
        <a-tabs :activeKey="activeTab" @change="handleTabChange">
          <!-- Pestaña 1: Ver en lista -->
          <a-tab-pane key="1" tab="Ver en lista">
            <div
              class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-4 mt-4 search-complaints"
            >
              <!-- Tabla de datos de sesiones -->
              <SessionsTable
                :dataSource="sessionsAgiliza"
                @changeStateFacilitator="changeStateFacilitator"
                @goToComplaintDetail="handleGoToComplaintDetail"
                @scheduleSession="handleScheduleSession"
                @accessSession="handleAccessSession"
                @recordCloseMediationSession="handleRecordCloseMediationSession"
                @viewSessionDetails="handleViewSessionDetails"
              />

              <div class="p-4 flex justify-end">
                <a-pagination
                  v-model="page"
                  :page-size="pageSize"
                  :page-size-options="pageSizeOptions"
                  :total="count"
                  show-size-changer
                  size="large"
                  @showSizeChange="onShowSizeChange"
                  @change="onChange"
                />
              </div>
            </div>
          </a-tab-pane>

          <!-- Pestaña 2: Ver en calendario -->
          <a-tab-pane key="2" tab="Ver en calendario">
            <div class="h-screen max-h-[80vh]">
              <SessionsCalendar
                :events="sessionsAgiliza"
                :externalSelectedSession="selectedSessionForCalendar"
                @refresh="fetchData"
              />
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>

    <!-- Modal de detalle de sesión -->
    <SessionDetailModal
      :visible="isModalVisible"
      :session-data="selectedSessionData"
      @close="closeModal"
      @access="handleAccessSession(selectedSessionData)"
      @goToComplaintDetail="handleGoToComplaintDetail"
      @reschedule="handleRescheduleSession"
    />
  </div>
</template>

<script>
import SessionsFilter from "../partials/SessionsFilter.vue";
import SessionsTable from "../partials/SessionsTable.vue";
import SessionsCalendar from "../partials/SessionsCalendar.vue";
import SessionDetailModal from "../partials/SessionDetailModal.vue";
import TotalComplaints from "@/components/Dashboard/Complaints/TotalComplaints.vue";
import complaintsAgilizaServicesImplementation from "@/feature/dashboard/complaints_agiliza/data/services/complaints_agiliza_services_impl";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "@/core/utils/constants";
import ErrorMessaje from "@/core/error/error_messaje";
import Management from "@/feature/customer/complaint/presentation/views/management.vue";

export default {
  props: ["userFacilitatorId"],
  components: {
    TotalComplaints,
    SessionsFilter,
    SessionsTable,
    SessionsCalendar,
    SessionDetailModal,
    Management,
  },
  data() {
    return {
      activeTab: "1",
      sessionsAgilizaType: "Ver en lista",
      count: 0,
      loading: false,
      form: {},
      page: DEFAULT_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
      pageSizeOptions: ["50", "100", "150", "200", "250"],
      searching: false,
      sessionsAgiliza: [],
      msgToModal: "",
      selectedSessionForCalendar: null,
      isModalVisible: false,
      selectedSessionData: {},
    };
  },
  methods: {
    handleGoToComplaintDetail(record) {
      this.$router.push(
        `/dashboard/complaint/details?complaint_id=${record.codigo_queja}&type=agiliza&action=sesion`,
      );
    },
    handleTabChange(key) {
      switch (key) {
        case "1":
          this.sessionsAgilizaType = "Ver en lista";
          this.selectedSessionForCalendar = null;
          break;
        case "2":
          this.sessionsAgilizaType = "Ver en calendario";
          break;
        default:
          this.sessionsAgilizaType = "Ver en lista";
      }
      if (key) {
        this.activeTab = key;
      }
    },
    handleRecordCloseMediationSession(record) {
      this.$router.push({
        name: "SessionsAgilizaOutcome",
        params: { codigoQueja: record.codigo_queja },
      });
    },
    handleScheduleSession(record) {
      this.selectedSessionForCalendar = record;
      this.handleTabChange("2");
    },
    handleAccessSession(record) {
      if (record && record.session_link) {
        window.open(record.session_link, "_blank");
      }
    },
    handleViewSessionDetails(record) {
      this.selectedSessionData = record;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.selectedSessionData = {};
    },
    async handleRescheduleSession() {
      try {
        const response =
          await complaintsAgilizaServicesImplementation.rescheduleSessionAgiliza(
            this.selectedSessionData.session_agiliza_id,
          );

        if (response.isSuccess) {
          this.showToast("info", response.data.message);
        } else {
          let errorMsg = ErrorMessaje.generalError;
          if (response.data && response.data.message) {
            errorMsg = response.data.message;
          }
          this.showToast("error", errorMsg);
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.closeModal();
        this.fetchData();
      }
    },
    async setFilterForm(form, pagination) {
      this.form = form;

      if (pagination.page && pagination.pageSize) {
        this.page = pagination.page;
        this.pageSize = pagination.pageSize;
      }
      await this.fetchData();
    },

    async fetchData() {
      this.loading = true;
      this.searching = true;
      const pagination = {
        page: this.page,
        pageSize: this.pageSize,
      };

      try {
        const response =
          await complaintsAgilizaServicesImplementation.getSessionsAgiliza(
            pagination,
            this.form,
          );

        if (response.isSuccess) {
          response.count = response.data.count;

          this.setDeafultEmited(response.data.count, response.data);
          return;
        } else {
          this.showToast("error", response.message);
          this.setDeafultEmited(null);
          return;
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
        this.setDeafultEmited(null);
      } finally {
        this.loading = false;
        this.searching = false;
      }
    },
    async changeStateFacilitator(checked, record) {
      this.loading = true;
      this.searching = true;

      const data = {
        is_receiving_scheduling: checked,
      };

      try {
        const response =
          await complaintsAgilizaServicesImplementation.updateAgilizaFacilitatorState(
            record.id,
            data,
          );

        if (response.isSuccess) {
          this.msgToModal =
            "Estado del facilitador actualizado correctamente - INICIAL";
          if (response.data && response.data.message) {
            this.msgToModal = response.data.message;
          }
          this.showToast("success", this.msgToModal);
          await this.fetchData();
          return;
        } else {
          let errorMessage = ErrorMessaje.generalError;
          if (response.data && response.data.error) {
            errorMessage = response.data.error;

            if (response.data && response.data.detail) {
              errorMessage = errorMessage + " - " + response.data.detail;
            }
          }
          this.showToast("error", errorMessage);
          return;
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.loading = false;
        this.searching = false;
      }
    },
    setDeafultEmited(count, resp) {
      this.count = count || 0;
      const data = resp?.results || [];

      if (data.length > 0) {
        this.sessionsAgiliza = data.map((element) => {
          const sessionDate = element.session_date
            ? `${this.formatSessionDate(
                element.session_date,
              )} ${this.formatSessionTime(
                element.session_start_time,
              )} - ${this.formatSessionTime(element.session_end_time)}`
            : "Pendiente";

          const formattedDate = element.creation_date
            ? element.creation_date.replace("T", " ")
            : "";
          return {
            ...element,
            codigo_queja: element.codigo_queja
              ? String(element.codigo_queja)
              : "",
            nameCf: element.cf ? element.cf.nombre_completo : "",
            nameEv: element.ev ? element.ev.razon_social : "",
            session_date_original: element.session_date,
            session_date: sessionDate,
            creation_date: formattedDate,
          };
        });
      } else {
        this.sessionsAgiliza = [];
      }
    },
    // Cambio de tamaño de página
    onShowSizeChange(page, page_size) {
      // Ante el cambio en el tamaño de la pagina se debe reiniciar la página a 1
      this.page = 1;
      this.pageSize = page_size;
      this.fetchData();
    },
    // Cambio de página
    onChange(page, page_size) {
      this.page = page;
      this.pageSize = page_size;
      this.fetchData();
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
    formatSessionDate(fecha) {
      const [year, month, day] = fecha.split("-");

      const date = new Date(year, month - 1, day);

      const mes = date.toLocaleString("es-ES", {
        month: "long",
      });

      return `${day} de ${
        mes.charAt(0).toUpperCase() + mes.slice(1)
      } de ${year}`;
    },
    formatSessionTime(time) {
      if (!time) {
        return "";
      }

      return new Date(`1970-01-01T${time}`).toLocaleTimeString("es-CO", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
    totalFacilitatorsBody() {
      return this.count === 1 ? "sesión" : "sesiones";
    },
  },
};
</script>

<style></style>
